import axios from 'axios';
import authHeader from './auth-header';
const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    async getGuest() {
        const response = await axios.get(API_URL + "/guest", { headers: authHeader() });
        return response.data;
    },

    async getGuestById(guestId) {
        const response = await axios.get(API_URL + "/guest/" + guestId, { headers: authHeader() });
        return response.data;
    },

    async createPassword() {
        const response = await axios.post(API_URL + "/guest/create-password", {}, { headers: authHeader() });
        return response.data.password;
    },

    async updatePassword(id, password) {
        const response = await axios.patch(API_URL + "/guest/update-password/" + id, { password }, { headers: authHeader() });
        return response.data.message;
    },
};